module.exports = __webpack_public_path__ + "img/hungary.b9d87010.png";